const copyToClipboard = str => {
    navigator.clipboard.writeText(str)
};
export default copyToClipboard;